exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dis-flex{display:flex}.select-modal-wrap{width:100%;height:100%;background-color:rgba(0,0,0,0.5);position:fixed;bottom:0;left:0;z-index:1001}.select-modal-wrap .select-modal{position:absolute;bottom:0;width:100%;min-height:53.33333vw;background-color:#fff}\n", ""]);

// exports
